namespace TabAurous.Production {
    export interface JobWorkReceiptBOMRow {
        TransBomId?: number;
        TransItemId?: number;
        TransId?: number;
        ProductId?: number;
        BomProductId?: number;
        ProductCode?: string;
        CalcOnId?: number;
        AttributeId?: number;
        Attribute?: string;
        ItemTypeId?: number;
        BagNo?: string;
        LotNo?: string;
        Line_No?: number;
        Pieces?: number;
        Weight?: number;
        Purity?: number;
        PureWeight?: number;
        StoneColorId?: number;
        MetalColorId?: number;
        QualityId?: number;
        KaratId?: number;
        ShapeId?: number;
        StoneSizeId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        SettingId?: number;
        SettingName?: string;
        BomRate?: number;
        BomAmount?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        RefTransBomId?: number;
        IsCustomerItem?: boolean;
        Markup?: number;
        Lab?: string;
        CertificateNo?: string;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        ProductName?: string;
        ItemType?: string;
        CalcOn?: string;
        ProductTypeId?: number;
        SubCategoryId?: number;
        CategoryId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
    }

    export namespace JobWorkReceiptBOMRow {
        export const idProperty = 'TransBomId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.JobWorkReceiptBOM';
        export const deletePermission = 'Production:JobWorkReceipt:Delete';
        export const insertPermission = 'Production:JobWorkReceipt:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:JobWorkReceipt:Edit';

        export declare const enum Fields {
            TransBomId = "TransBomId",
            TransItemId = "TransItemId",
            TransId = "TransId",
            ProductId = "ProductId",
            BomProductId = "BomProductId",
            ProductCode = "ProductCode",
            CalcOnId = "CalcOnId",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            ItemTypeId = "ItemTypeId",
            BagNo = "BagNo",
            LotNo = "LotNo",
            Line_No = "Line_No",
            Pieces = "Pieces",
            Weight = "Weight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            StoneColorId = "StoneColorId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            KaratId = "KaratId",
            ShapeId = "ShapeId",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            SettingId = "SettingId",
            SettingName = "SettingName",
            BomRate = "BomRate",
            BomAmount = "BomAmount",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefTransBomId = "RefTransBomId",
            IsCustomerItem = "IsCustomerItem",
            Markup = "Markup",
            Lab = "Lab",
            CertificateNo = "CertificateNo",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            ProductName = "ProductName",
            ItemType = "ItemType",
            CalcOn = "CalcOn",
            ProductTypeId = "ProductTypeId",
            SubCategoryId = "SubCategoryId",
            CategoryId = "CategoryId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName"
        }
    }
}
